var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserMedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.2983H8C5.2 14.2983 3 16.4983 3 19.2983V21.2983C3 21.8983 3.4 22.2983 4 22.2983C4.6 22.2983 5 21.8983 5 21.2983V19.2983C5 17.5983 6.3 16.2983 8 16.2983H16C17.7 16.2983 19 17.5983 19 19.2983V21.2983C19 21.8983 19.4 22.2983 20 22.2983C20.6 22.2983 21 21.8983 21 21.2983V19.2983C21 16.4983 18.8 14.2983 16 14.2983Z",
    fill: "#00214D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.2983C14.8 12.2983 17 10.0983 17 7.29834C17 4.49834 14.8 2.29834 12 2.29834C9.2 2.29834 7 4.49834 7 7.29834C7 10.0983 9.2 12.2983 12 12.2983ZM12 4.29834C13.7 4.29834 15 5.59834 15 7.29834C15 8.99834 13.7 10.2983 12 10.2983C10.3 10.2983 9 8.99834 9 7.29834C9 5.59834 10.3 4.29834 12 4.29834Z",
    fill: "#00214D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserMedis);
export default __webpack_public_path__ + "static/media/iconUserMedis.41cf87f54a1c75b2df27fcd5a170c6e1.svg";
export { ForwardRef as ReactComponent };